import classNames from "classnames";
import { FC } from "react";
import { API } from "../../../services/api/types";
import { minifyUrl } from "../../../utils/minifyUrl";
import Flag from "../../Flag";
import SectionHeader from "../../SectionHeader";
import Table from "../../Table/Table";
import TableBody from "../../Table/TableBody";
import { MdChevronRight } from "react-icons/md"
import Link from 'next/link';
import slugify from '../../../utils/slugify';

type ProfileTableProps = {
  agent: API.Agent;
};

const ProfileTable: FC<ProfileTableProps> = ({ agent }) => {
  const showProfile = Boolean(
    agent.homepage || agent.about || agent.nationalitiesText || agent.licenseName
  );

  return (
    <>
      <SectionHeader label="Agentprofil" />
      {showProfile ? (
        <Table overflowScroll={false}>
          <TableBody rowHeight="sm">
            {agent.nationalitiesText ? (
              <tr>
                <td>Nationalitet:</td>
                <td className={classNames("font-semibold")}>
                  <span className='flex items-center'>
                    <span className='mr-2'>{agent.nationalitiesText}</span>
                    <Flag
                      country={agent.nationalitiesText}
                    />
                  </span>
                </td>
              </tr>
            ) : null}

            {agent.homepage ? (
              <tr>
                <td>Webbplats:</td>
                <td className={classNames("font-semibold")}>
                  <a
                    href={agent.homepage}
                    rel="noreferrer"
                    target="_blank"
                    className={classNames("break-all", "hover:underline")}
                  >
                    {minifyUrl(agent.homepage)}
                  </a>
                </td>
              </tr>
            ) : null}

            {agent.about ? (
              <tr>
                <td>Om:</td>
                <td className={classNames("font-semibold", "break-words")}>
                  <span
                    className={classNames("break-words")}
                    dangerouslySetInnerHTML={{ __html: agent.about }}
                  />
                </td>
              </tr>
            ) : null}

            {agent.agency !== null ? (
              <tr>
              <td>Typ:</td>
              <td className={classNames("font-semibold")}>
                {Boolean(agent.agency) ? 'Agentur' : 'Agent'}
              </td>
            </tr>
            ) : null}

            {[1, 2, 4].includes(agent.licenseId) ? (
              <tr>
              <td>Licens:</td>
              <td className={classNames("font-semibold")}>
                {agent.licenseName}
              </td>
            </tr>
            ) : null}

        {agent.playerProfileId && agent.playerProfileId > 0 ? (
          <Link href={`/spelare/${slugify(agent.playerProfileName || '')}/${agent.playerProfileId}`}>
            <tr className='cursor-pointer hover:underline'>
              <td className={classNames("font-semibold whitespace-nowrap")}>Visa spelarprofil</td>
              <td><MdChevronRight className="ml-auto" size={20}/></td>
              </tr>
          </Link>) : null}
          </TableBody>
        </Table>
      ) : (
        <p
          className={classNames(["py-5", "px-4", "border-b", "font-semibold"])}
        >
          Ingen information att visa
        </p>
      )}
    </>
  );
};

export default ProfileTable;
